module.exports = __webpack_public_path__ + "static/media/bigfoot_ranking_app.a9c12371.md";